module.exports = __webpack_public_path__ + "dm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/dm.svg
// module id = 522
// module chunks = 0